export const DestNameKerala = "Kerala";
export const DestNameDubai = "Dubai";
export const DestNameKarnataka = "Karnataka";
export const DestNameKashmir = "Kashmir";
export const DestNameHimachal = "Himachal";
export const DestNameUttrakhand = "Uttrakhand";
export const DestNameRajasthan = "Rajasthan";
export const DestNameSikkimDarjeeling = "Sikkim_Darjeeling";
export const DestNameSikkim = "Sikkim";
export const DestNameGoa = "Goa";
export const DestNameBali = "Bali";
export const DestNameNepal = "Nepal";
export const DestNameBhutan = "Bhutan";
export const DestNameVietnam = "Vietnam";
export const DestNameMaharashtra = "Maharashtra";
export const DestNamePuducherry = "Puducherry";
export const DestNameTamilNadu = "Tamil Nadu";
export const DestNameThailand = "Thailand";
export const DestNameEurope = "Europe";
export const DestNameTurkey = "Turkey";
export const DestNameSriLanka = "SriLanka";
export const DestNameAndaman = "Andaman";
export const DestNameMeghalaya = "Meghalaya";
export const DestNameAssam = "Assam";
export const DestNameArunanchal = "Arunanchal Pradesh";
export const DestNameGujarat = "Gujarat";
export const DestNameDelhi = "Delhi";
export const DestNameOthers = "Others";

export const DestinationNames = [
  DestNameKerala,
  DestNameKarnataka,
  DestNameKashmir,
  DestNameHimachal,
  DestNameSikkimDarjeeling,
  DestNameSikkim,
  DestNameDubai,
  DestNameBhutan,
  DestNameUttrakhand,
  DestNameRajasthan,
  DestNameMaharashtra,
  DestNameGoa,
  DestNameNepal,
  DestNamePuducherry,
  DestNameBali,
  DestNameVietnam,
  DestNameTamilNadu,
  DestNameThailand,
  DestNameEurope,
  DestNameTurkey,
  DestNameSriLanka,
  DestNameAndaman,
  DestNameMeghalaya,
  DestNameAssam,
  DestNameArunanchal,
  DestNameGujarat,
  DestNameDelhi,
];
export const DestImgData = {
  "kerala": {
    img: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944",
    title: "Kerala",
    value: "Kerala",
    imgList: [
      "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944",
      "https://images.unsplash.com/photo-1597735881932-d9664c9bbcea?q=70&w=683",
      "https://images.unsplash.com/photo-1641666017842-f94246ef2961?q=70&w=500"
    ]
  },
  "karnataka": {
    img: "https://images.unsplash.com/photo-1631714712922-eaa39e4452fa",
    title: "Karnataka",
    value: "Karnataka",
    imgList: [
      "https://images.unsplash.com/photo-1631714712922-eaa39e4452fa",
      "https://images.unsplash.com/photo-1620766182966-c6eb5ed2b788?q=70&w=500",
      "https://images.unsplash.com/photo-1590766940554-634a7ed41450?q=70&w=800&auto=format&fit=crop"
    ]
  },
  "tamil nadu": {
    img: "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?q=80&w=500&auto=format&fit=crop",
    title: "Tamil Nadu",
    value: "Tamil Nadu",
    imgList: [
      "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?q=80&w=500&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1617777854432-2c66c79f970a?q=70&w=600&auto=format",
      "https://images.unsplash.com/photo-1595433306946-233f47e4af3a?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "kashmir": {
    img: "https://images.unsplash.com/photo-1616190419596-e2839e7380d7",
    title: "Kashmir",
    value: "Kashmir",
    imgList: [
      "https://images.unsplash.com/photo-1616190419596-e2839e7380d7",
      "https://images.unsplash.com/photo-1598091383021-15ddea10925d?q=70&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1669378539802-defdc9409e07?q=70&w=764&auto=format&fit=crop"
    ]
  },
  "himachal": {
    img: "https://images.unsplash.com/photo-1651317720959-2ee65b345736?q=80&w=500&auto=format&fit=crop",
    title: "Himachal",
    value: "Himachal",
    imgList: [
      "https://images.unsplash.com/photo-1651317720959-2ee65b345736?q=80&w=800&auto=format&fit=crop",
      "https://plus.unsplash.com/premium_photo-1661952578770-79010299a9f9?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1653844573020-71f77a0ccb8c?q=70&w=600&auto=format&fit=crop"
    ]
  },
  "ladakh": {
    img: "https://plus.unsplash.com/premium_photo-1661949303004-bab6b7a82912?q=80&w=500&auto=format&fit=crop",
    title: "Ladakh",
    value: "Ladakh",
    imgList: [
      "https://plus.unsplash.com/premium_photo-1661949303004-bab6b7a82912?q=80&w=700&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1593118845043-359e5f628214?q=70&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1600356033695-a003690a6351?q=70&w=800&auto=format&fit=crop"
    ]
  },
  "uttarakhand": {
    img: "https://images.unsplash.com/photo-1586618761884-a062d527523f?q=80&w=500&auto=format&fit=crop",
    title: "Uttarakhand",
    value: "Uttarakhand",
    imgList: [
      "https://images.unsplash.com/photo-1586618761884-a062d527523f?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1716573260891-23ad993e8833?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1712510817140-917938f92e5b?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "uttar pradesh": {
    img: "https://images.unsplash.com/photo-1706185619150-9515423d32fc?q=80&w=500&auto=format&fit=crop",
    title: "Uttar Pradesh",
    value: "Uttar Pradesh",
    imgList: [
      "https://images.unsplash.com/photo-1706185619150-9515423d32fc?q=80&w=500&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1717323821798-8cee2f6826ff?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1702175605824-427df95987bd?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1648036339760-50ca3070c107?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "rajasthan": {
    img: "https://plus.unsplash.com/premium_photo-1661962556769-5beec5563911?q=80&w=500&auto=format&fit=crop",
    title: "Rajasthan",
    value: "Rajasthan",
    imgList: [
      "https://plus.unsplash.com/premium_photo-1661962556769-5beec5563911?q=80&w=500&auto=format&fit=crop",
      "https://plus.unsplash.com/premium_photo-1661962428918-6a57ab674e23?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1638904998527-a451c1fbd1cb?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1477587458883-47145ed94245?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "gujarat": {
    img: "https://images.unsplash.com/photo-1642841819300-20ed449c02a1?w=500&auto=format&fit=crop",
    title: "Gujarat",
    value: "Gujarat",
    imgList: [
      "https://images.unsplash.com/photo-1642841819300-20ed449c02a1?w=500&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1549468057-5b7fa1a41d7a?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1621680956501-ed0fd0118958?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "sikkim-darjeeling": {
    img: "https://plus.unsplash.com/premium_photo-1697730400710-9e565f54869e?q=80&w=500&auto=format&fit=crop",
    title: "Sikkim-Darjeeling",
    value: "Sikkim_Darjeeling",
    imgList: [
      "https://images.unsplash.com/photo-1600402808924-9c591a6dace8?q=80&w=800&auto=format&fit=crop",
      "https://plus.unsplash.com/premium_photo-1697730400710-9e565f54869e?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1515747802812-e9226ae7e01b?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "assam": {
    img: "https://images.unsplash.com/photo-1613725194245-d8e21cf5d42e?q=80&w=500&auto=format&fit=crop",
    title: "Assam",
    value: "Assam",
    imgList: [
      "https://images.unsplash.com/photo-1613725194245-d8e21cf5d42e?q=80&w=500&auto=format&fit=crop",
      "https://images.pexels.com/photos/7191012/pexels-photo-7191012.jpeg",
      "https://images.pexels.com/photos/36719341/pexels-photo-36719341.jpeg"
    ]
  },
  "meghalaya": {
    img: "https://images.unsplash.com/photo-1552978534-9d01e1f91517?w=600&auto=format&fit=crop&q=60",
    title: "Meghalaya",
    value: "Meghalaya",
    imgList: [
      "https://images.unsplash.com/photo-1552978534-9d01e1f91517?w=800&auto=format&fit=crop&q=60",
      "https://images.unsplash.com/photo-1609276804051-8c5e906cc430?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1594514113865-d1deac339435?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "arunanchal": {
    img: "https://i.pinimg.com/736x/ae/6a/ff/ae6affc9ba5854b6f1a733dc77ce302d.jpg",
    title: "Arunanchal",
    value: "Arunanchal",
    imgList: [
      "https://i.pinimg.com/736x/ae/6a/ff/ae6affc9ba5854b6f1a733dc77ce302d.jpg",
      "https://images.unsplash.com/photo-1672399452678-dba92a84725f?q=80&w=500&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1672399447224-b63b8f67b44d?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1648963798678-a921079b98b9?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "mizoram": {
    img: "https://images.unsplash.com/photo-1754162161390-2c458b3a6e55?q=80&w=500&auto=format&fit=crop",
    title: "Mizoram",
    value: "Mizoram",
    imgList: [
      "https://images.unsplash.com/photo-1754162161390-2c458b3a6e55?q=80&w=800&auto=format&fit=crop",
      "https://images.pexels.com/photos/4324494/pexels-photo-4324494.jpeg",
      "https://images.unsplash.com/photo-1744262056245-70eefd885e10?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "hyderabad": {
    img: "https://images.unsplash.com/photo-1657981630164-769503f3a9a8?w=600&auto=format&fit=crop&q=60",
    title: "Hyderabad",
    value: "Hyderabad",
    imgList: [
      "https://images.unsplash.com/photo-1657981630164-769503f3a9a8?w=600&auto=format&fit=crop&q=60",
      "https://images.unsplash.com/photo-1615790456401-4cab86cd2408?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1719668027123-0af1516aa9fa?q=70&w=735&auto=format&fit=crop"
    ]
  },
  "odisha": {
    img: "https://images.unsplash.com/photo-1638441173566-fc4ca312d0f8?q=80&w=500&auto=format&fit=crop",
    title: "Odisha",
    value: "Odisha",
    imgList: [
      "https://images.unsplash.com/photo-1638441173566-fc4ca312d0f8?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1621100819796-9035a9120965?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1633410195091-bd66114cef5f?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "dubai": {
    img: "https://images.unsplash.com/flagged/photo-1559717865-a99cac1c95d8",
    title: "Dubai",
    value: "Dubai",
    imgList: [
      "https://images.unsplash.com/flagged/photo-1559717865-a99cac1c95d8",
      "https://images.unsplash.com/photo-1628859017536-c2f1d69f3c84?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1576159470850-494c8b17aca0?q=80&w=800&auto=format"
    ]
  },
  "bali": {
    img: "https://images.unsplash.com/photo-1577717903315-1691ae25ab3f?w=800&auto=format&fit=crop&q=60",
    title: "Bali",
    value: "Bali",
    imgList: [
      "https://images.unsplash.com/photo-1577717903315-1691ae25ab3f?w=800&auto=format&fit=crop&q=60",
      "https://images.unsplash.com/photo-1604999333679-b86d54738315?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1566987827585-6c556cc32848?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "vietnam": {
    img: "https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?w=600&auto=format&fit=crop&q=60",
    title: "Vietnam",
    value: "Vietnam",
    imgList: [
      "https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1526139334526-f591a54b477c?q=80&w=800&auto=format&fit=crop",
      "https://plus.unsplash.com/premium_photo-1719955783083-6a0bd66c5f75?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "thailand": {
    img: "https://images.unsplash.com/photo-1528181304800-259b08848526?q=80&w=500&auto=format&fit=crop",
    title: "Thailand",
    value: "Thailand",
    imgList: [
      "https://images.unsplash.com/photo-1528181304800-259b08848526?q=80&w=800&auto=format&fit=crop",
      "https://plus.unsplash.com/premium_photo-1661962958462-9e52fda9954d?q=80&w=800&auto=format&fit=crop",
      "https://plus.unsplash.com/premium_photo-1661962432490-6188a6420a81?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "malaysia": {
    img: "https://images.unsplash.com/photo-1577931683033-1059552104e0?q=80&w=500&auto=format&fit=crop",
    title: "Malaysia",
    value: "Malaysia",
    imgList: [
      "https://images.unsplash.com/photo-1577931683033-1059552104e0?q=80&w=500&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1712601979098-15dccb4d0996?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1564506414752-a73fbe0c6b00?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "singapore": {
    img: "https://images.unsplash.com/photo-1775306963755-8897be3967bb?q=80&w=500&auto=format&fit=crop",
    title: "Singapore",
    value: "Singapore",
    imgList: [
      "https://images.unsplash.com/photo-1775306963755-8897be3967bb?q=80&w=500&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1552415274-73ad7198cb93?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "bhutan": {
    img: "https://images.unsplash.com/photo-1567241803528-0e183644074f?q=80&w=500&auto=format&fit=crop",
    title: "Bhutan",
    value: "Bhutan",
    imgList: [
      "https://images.unsplash.com/photo-1567241803528-0e183644074f?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1578556881786-851d4b79cb73?q=80&w=800&auto=format&fit=crop",
      "https://plus.unsplash.com/premium_photo-1691735666207-be6e91326e3a?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "nepal": {
    img: "https://images.unsplash.com/photo-1571401835393-8c5f35328320?w=600&auto=format&fit=crop&q=60",
    title: "Nepal",
    value: "Nepal",
    imgList: [
      "https://images.unsplash.com/photo-1571401835393-8c5f35328320?w=800&auto=format&fit=crop&q=60",
      "https://images.unsplash.com/photo-1526712318848-5f38e2740d44?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1611516491426-03025e6043c8?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "sri lanka": {
    img: "https://images.unsplash.com/photo-1580910527739-556eb89f9d65?w=600&auto=format&fit=crop&q=60",
    title: "Sri Lanka",
    value: "Sri Lanka",
    imgList: [
      "https://images.unsplash.com/photo-1580910527739-556eb89f9d65?w=800&auto=format&fit=crop&q=60",
      "https://images.unsplash.com/photo-1612862862126-865765df2ded?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1651264042769-ef84e30f4ac8?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "georgia": {
    img: "https://images.unsplash.com/photo-1704278189296-b9bc26f49ceb?q=80&w=735&auto=format&fit=crop",
    title: "Georgia",
    value: "Georgia",
    imgList: [
      "https://images.unsplash.com/photo-1704278189296-b9bc26f49ceb?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1505294399615-2479253a4990?q=80&w=800&auto=format&fit=crop"
    ]
  }, 
  "azerbaijan": {
    img: "https://images.unsplash.com/photo-1596306499398-8d88944a5ec4?q=80&w=800&auto=format&fit=crop",
    title: "Azerbaijan",
    value: "Azerbaijan",
    imgList: [
      "https://images.unsplash.com/photo-1596306499398-8d88944a5ec4?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1621856818321-5b3a11cc6b18?q=80&w=800&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1585769868729-dc68190cf80d?q=80&w=800&auto=format&fit=crop"
    ]
  }, 
  "europe": {
    img: "https://images.unsplash.com/photo-1485081669829-bacb8c7bb1f3?q=80&w=500&auto=format&fit=crop",
    title: "Europe",
    value: "Europe",
    imgList: [
      "https://images.unsplash.com/photo-1485081669829-bacb8c7bb1f3?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "oman": {
    img: "https://images.unsplash.com/photo-1621680696874-edd80ce57b72?w=600&auto=format&fit=crop&q=60",
    title: "Oman",
    value: "Oman",
    imgList: [
      "https://images.unsplash.com/photo-1621680696874-edd80ce57b72?w=600&auto=format&fit=crop&q=60"
    ]
  },
  "kazakhstan": {
    img: "https://plus.unsplash.com/premium_photo-1674682034730-95dbc3cce1c3?w=600&auto=format&fit=crop&q=60",
    title: "Kazakhstan",
    value: "Kazakhstan",
    imgList: [
      "https://plus.unsplash.com/premium_photo-1674682034730-95dbc3cce1c3?w=600&auto=format&fit=crop&q=60"
    ]
  },
  "japan": {
    img: "https://plus.unsplash.com/premium_photo-1661878091370-4ccb8763756a?w=600&auto=format&fit=crop&q=60",
    title: "Japan",
    value: "Japan",
    imgList: [
      "https://plus.unsplash.com/premium_photo-1661878091370-4ccb8763756a?w=600&auto=format&fit=crop&q=60",
      "https://images.unsplash.com/photo-1542051841857-5f90071e7989?q=80&w=800&auto=format&fit=crop"
    ]
  },
  "australia": {
    img: "https://plus.unsplash.com/premium_photo-1706517229833-f41d68aae8ff?w=600&auto=format&fit=crop&q=60",
    title: "Australia",
    value: "Australia",
    imgList: [
      "https://plus.unsplash.com/premium_photo-1706517229833-f41d68aae8ff?w=600&auto=format&fit=crop&q=60"
    ]
  },
  // {
  //   img: "https://images.unsplash.com/photo-1704278189296-b9bc26f49ceb?q=80&w=735&auto=format&fit=crop",
  //   title: "Georgia",
  //   value: "Georgia",
  // },
  // {
  //   img: "https://images.unsplash.com/photo-1704278189296-b9bc26f49ceb?q=80&w=735&auto=format&fit=crop",
  //   title: "Georgia",
  //   value: "Georgia"
  // },
  // {
  //   img: "https://images.unsplash.com/photo-1704278189296-b9bc26f49ceb?q=80&w=735&auto=format&fit=crop",
  //   title: "Georgia",
  //   value: "Georgia"
  // },
  // {
  //   img: "https://images.unsplash.com/photo-1704278189296-b9bc26f49ceb?q=80&w=735&auto=format&fit=crop",
  //   title: "Georgia",
  //   value: "Georgia"
  // },
  // {
  //   img: "https://images.unsplash.com/photo-1704278189296-b9bc26f49ceb?q=80&w=735&auto=format&fit=crop",
  //   title: "Georgia",
  //   value: "Georgia"
  // },

  // ,
  // {
  //   img: "https://images.unsplash.com/photo-1524661135-423995f22d0b?q=80&w=500&auto=format&fit=crop",
  //   title: "Any Other Destination",
  //   value: "Others"
  // },
};
export const DestImgArr = Object.values(DestImgData);

export const BookingStatusAll = "all";
export const BookingStatusActive = "active";
export const BookingStatusCompleted = "completed";
export const BookingStatusCancelled = "cancelled";

export const BookingTypes = [
  BookingStatusActive,
  BookingStatusCompleted,
  BookingStatusCancelled,
  BookingStatusAll,
];

export const CabTypes = ["Sedan", "Suv", "Hatchback", "Traveller", "Bus"];
export const HotelRatingTypes = ["3*", "4* Budget", "4* Premium", "5*", "Luxury"];

export const BID_DECLINED_STATUS_TYPE = "declined";
export const BID_DEFAULT_STATUS_TYPE = "pending";
export const BID_ACCEPTED_STATUS_TYPE = "accepted";
export const REQ_ACTIVE_STATUS_TYPE = "active";
export const REQ_EXPIRED_STATUS_TYPE = "expired";
export const REQ_BOOKED_STATUS_TYPE = "booked";
export const REQ_BOOKED_OUT_STATUS_TYPE = "booked_outside";
export const REQ_CANCELLED_STATUS_TYPE = "cancelled";

export const REQ_BOOKED_W_YOU_STATUS_LABEL = "Booked With You";
export const REQ_WAITING_STATUS_LABEL = "Waiting For Confirmation";
export const REQ_NEED_BETTER_PRICE_STATUS_LABEL = "Needs Better Price";
export const REQ_NO_RES_STATUS_LABEL = "No Response";
export const REQ_INVALID_BIDS_STATUS_LABEL = "Invalid Bid";
export const REQ_BOOKED_OUT_STATUS_LABEL = "Booked Outside";
// export const REQ_BOOKED_W_YOU_STATUS_TYPE = "booked_with_you";

export const BOOKING_ACTIVE_STATUS_TYPE = "active";
export const BOOKING_CANCELLED_STATUS_TYPE = "cancelled";
// export const BOOKING_CANCELLED_STATUS_TYPE = 'cancelled';
export const MAX_TEXT_LENGTH_OTHERINFO = 2000;

export const REQ_DETAIL_CARD_FONT_MOBILE = "0.79rem";
export const REQ_DETAIL_CARD_FONT_DESKTOP = "0.79rem";
export const REQ_EXPIRE_TIMEOUT_DAYS = 15; //1000;
export const BOOKING_EXPIRE_TIMEOUT_DAYS = 3;
export const KYC_PENDING_LINK =
  process.env.NODE_ENV === "production"
    ? "https://cabeasy.in/kyc-pending"
    : "https://persuasive-ego-377212.web.app/kyc-pending";
export const BOOKING_CHAT_TYPE_SYSTEM = "cb-system";
export const KYC_FORM_LINK = "https://forms.gle/tR1p39JZH2afo1NG8";  //"https://forms.gle/Lie3XbB8hFQEC4Ts7";
export const BOOKING_STATUS_STEPS = [
  {
    label: "Arrival/Hotel Details recieved",
    from: "agent",
    trackingFields: ["arrivalDetailsRecieved"],
    step: 1,
  },
  {
    label: "Driver&Cab Details Recieved",
    from: "supplier",
    trackingFields: ["driverDetailsRecieved"],
    step: 2,
  },
  {
    label: "Payment Recieved",
    from: "agent",
    trackingFields: ["completePaymentRecieved"],
    step: 3,
  },
  {
    label: "Trip Completed",
    from: "supplier",
    trackingFields: [
      "supplierMarkComplete",
      "agentMarkComplete"
    ],
    step: 4,
  },
  // {
  //   label: 'Feedback shared',
  //   from: 'supplier'
  // },
  // {
  //   label: 'Feedback shared',
  //   from: 'agent'
  // }
];

export const WHATSAPP_FORUM_LINK_AGENT = "https://bit.ly/CabEasyForum";
export const WHATSAPP_FORUM_LINK_SUPPLIER = "https://bit.ly/49I7y17";
export const OFFICIAL_WA_LINK = "https://wa.me/919266830896";
export const PHONE_FILTER_REGEX = /(?:\+?\d{1,3}[-.\s]?)?[\s\d]{10,14}/g;
export const EMAIL_FILTER_REGEX = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
export const BID_MSGS_MAX_LENGTH = 300;
export const CE_BID_DEFAULT_MARGIN_PERCENTAGE = 0.05;
export const BID_DECLINE_REASONS_TYPES = [
  {
    label: "Bid Too high!",
    value: "bid_too_high"
  },
  {
    label: "Incorrect Bid!",
    value: "bid_incorrect"
  },
  {
    label: "Bid Details not clear",
    value: "need_details"
  },
  {
    label: "Something else",
    value: "none_of_the_above"
  }
]
export const BOOKING_CANCEL_REASONS_TYPES = [
  {
    label: "Cusomization Not Included",
    value: "no_customization"
  },
  {
    label: "Have Better Price",
    value: "better_price"
  },
  {
    label: "Incorrect Price",
    value: "price_incorrect"
  },
  {
    label: "Something else",
    value: "none_of_the_above"
  }
]


export const PRIORITY_TEST = "dest_not_confirmed"
export const PRIORITY_FLEX = "dest_confirmed"
export const PRIORITY_BOOK = "tickets_booked"

export const PRIORITY_OPT = {
  [PRIORITY_TEST]: 'Query Not Confirmed',
  [PRIORITY_FLEX]: 'Flexible Dates',
  [PRIORITY_BOOK]: 'Query Confirmed',
}

export const PRIORITY_COLOR = {
  [PRIORITY_TEST]: 'gray',
  [PRIORITY_FLEX]: '#ffb833',
  [PRIORITY_BOOK]: 'yellowgreen',
}

export const CabEasyAccDetails = {
  accName: "CABEASY",
  bankName: "Yes Bank",
  branch: "",
  accNo: "095561900003148",
  ifsc: "YESB0000955"
}

export const FDPaymentAccDetails = {
  accName: "CABEASY",
  bankName: "Yes Bank",
  branch: "ROHINI SECTOR 8",
  accNo: "095561900003148",
  ifsc: "YESB0000955"
}

export const FDPaymentGpayNo = "yespay.smessi32615@yesbankltd";
export const CabEasyPayGpayNo = "yespay.smessi32615@yesbankltd";  //"+919266830896";
export const CB_SERVICE_GUARENTEE_FEE_INR = "99";
export const PBO_STEP_CONFIRM_ITI = "confirm_itinerary";
export const PBO_STEP_ARRIVAL_DETAILS = "submit_arrival_details";

export const REQ_STATUS_TAG = {
  active: { value: "Active", color: "green" },
  cancelled: { value: "Cancelled", color: "red" },
  expired: { value: "Expired", color: "grey" },
};

export const AGENT_RATING_LEVELS = [
  {
    minPoints: 0,
    maxPoints: 0.2,
    level: 1,
    stars: 3,
    label: "Bronze",
    title: 'BRONZE',
    color: "#cd7f32",
    perks: ['No Commission', 'Dedicated Support'],
  },
  {
    minPoints: 0.2,
    maxPoints: 0.4,
    level: 2,
    stars: 4,
    label: "Silver",
    title: 'SILVER',
    color: "#A5A5A8",
    perks: ['No Commission', '1 Fam Trip/Year'],
  },
  {
    minPoints: 0.4,
    maxPoints: Number.MAX_SAFE_INTEGER,
    level: 3,
    stars: 5,
    label: "Gold",
    title: 'GOLD',
    color: "#ffd700",
    perks: ['No Commission', '2 Fam Trip/Year'],
  }
]

export const SUPP_RATING_LEVELS = [
  {
    minPoints: 0,
    maxPoints: 2,
    level: 1,
    stars: 3,
    commissionRate: 0,
    label: "Bronze",
    color: "#cd7f32",
    title: 'BRONZE',
    perks: ['No Commission', '2 Free Bookings', 'Dedicated Support'],
  },
  {
    minPoints: 2,
    maxPoints: 5,
    level: 2,
    stars: 4,
    commissionRate: 8,
    label: "Silver",
    color: "#A5A5A8",
    title: 'SILVER',
    perks: ['8% Commission', 'Track your Bids like a Pro!', '1 Fam Trip / year'],
  },
  {
    minPoints: 5,
    maxPoints: Number.MAX_SAFE_INTEGER,
    level: 3,
    stars: 5,
    commissionRate: 5,
    label: "Gold",
    color: "#ffd700",
    title: 'GOLD',
    perks: ['5% Commission', 'Track your Bids like a Pro!', '2 Fam Trips / year'],
  }
]
export const SUPP_LEVEL_TC = [
  {
    text: 'Commission for CabEasy will be deducted from the Token Booking Amount payout.',
    link: null,
  },
  {
    text: 'Check Policy details and Terms of Use',
    link: { text: 'Here', href: '#' },
  },
  {
    text: 'Only Silver and Gold members will have access to Track Your Bids section.',
    link: { text: 'Track Your Bids', href: 'my-reqs?tab=trackSupp' },
  },
  {
    text: 'All discrepancies in a booking will be resolved according to details mentioned in the Booking chats on the CabEasy platform.',
    link: null,
  },
];

export const AGENT_LEVEL_TC = [
  {
    text: 'If your level goes down 🔻 (Ex. Silver -> Bronze OR Gold -> Silver), CabEasy will charge 1% commission till you are at the lower level.',
    link: null,
  },
  {
    text: 'As soon as your level increases🔺, no commission will be charged again.',
    link: null,
  },
  {
    text: 'Commission for CabEasy will be added to the Token Booking Amount.',
    link: null,
  },
  {
    text: 'Check Policy details and Terms of Use',
    link: { text: 'Here', href: '#' },
  },
  {
    text: 'All discrepancies in a booking will be resolved according to details mentioned in the Booking chats on the CabEasy platform.',
    link: null,
  },
];

export const CURRENCY_RATES = {
  "USD": 96,
  "AED": 26,
  "EUR": 109,
  "GBP": 128,
  "SGD": 74,
  "THB": 2.9,
  "IDR": 0.0053,
  "INR": 1
};

export const DUMMY_SUPP_ID = "+911234567890";

// cabeasy-db firebase app config
// REACT_APP_TERTIARY_COLOR = '#ffffe0'
// REACT_APP_FIREBASE_CONFIG_APIKEY = "AIzaSyC1qninpO2NfTF7NTBT34d6ndCzontvACo"
// REACT_APP_FIREBASE_CONFIG_AUTH_DOMAIN = "cabeasy-db.firebaseapp.com"
// REACT_APP_FIREBASE_CONFIG_PROJECTID = "cabeasy-db"
// REACT_APP_FIREBASE_CONFIG_STORAGE_BUCKET = "cabeasy-db.appspot.com"
// REACT_APP_FIREBASE_CONFIG_MESSAGING_SENDERID = "349157651963"
// REACT_APP_FIREBASE_CONFIG_APPID = "1:349157651963:web:6d9aff87cf15db3196075e"
// REACT_APP_CE_API_BASE_URL = "https://us-central1-cabeasy-db.cloudfunctions.net/webApi"
// REACT_APP_CABEASY_DOMAIN = "https://cabeasy.in"
// REACT_APP_CHECK_BIDS_URL_PATH = "/req/view-bids/"
// REACT_APP_POST_BIDS_URL_PATH = "/req/post-bid/"